<template>
  <section class="ui-pause">
    <div class="ui-pause__banner">
      <img src="/img/misc/banner-pause.png" alt="Banner pause">
    </div>

    <div class="ui-pause__content">
      <AppCurrentScore class="ui-pause__score" />

      <div class="ui-pause__buttons">
        <RoundedButton class="button--left" :content="$translate('menu').resume" action="resumeGame" />
        <RoundedButton class="button--right" :content="$translate('menu').leave" action="leaveGame" />
      </div>
    </div>
  </section>
</template>

<script>
import AppCurrentScore from '@/components/AppCurrentScore.vue';
import RoundedButton from '@/components/RoundedButton.vue';

export default {
  name: 'UIpause',

  components: {
    AppCurrentScore,
    RoundedButton,
  },
};
</script>

<style lang="scss" scoped>
.ui-pause {
  color: $white;

  @include gradient-bg(0.85);
  @extend %background-grain;

  &__banner {
    position: absolute;
    top: 20px;
    width: 200%;
    left: -60%;

    img {
      width: 100%;
      max-width: unset;
    }
  }

  &__content {
    position: absolute;
    bottom: 20px;
    width: 100%;
    height: 100%;
    padding-top: 20vh;
  }

  &__buttons,
  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
  }

  &__score {
    margin: 5vh 0 20vh;
  }

  &__buttons {
    margin-bottom: 5vh;

    > *:first-child {
      margin-bottom: 20px;
    }
  }

  @include mq(ipadP) {
    &__banner {
      top: 8vh;
      width: 100%;
      left: -3.5%;

      img {
        width: 95%;
      }
    }
  }

  @include mq(ipadL) {
    &__buttons {
      width: 26vw;
      min-width: 400px;

      justify-content: space-between;
      flex-flow: row wrap;

      *:first-child {
        margin-bottom: 0;
      }
    }
  }

  @include mq(ds) {
    &__banner {
      top: 8vh;
      width: 100%;
      left: -3.5%;

      img {
        width: 65%;
      }
    }

    &__score {
      margin: 10vh 0 20vh;
    }

    &__buttons {
      margin-bottom: 0;
    }
  }
}
</style>
